import { createFileRoute } from '@tanstack/react-router'
import { ShippingCalculatorPage } from '@/pages/shipping-calculator'

export const Route = createFileRoute('/_authenticated/shipping-calculator/')({
  staticData: { title: 'Shipping Calculator' },
  component: ShippingCalculatorPage,
})
